import { toReportNumber } from './reportNumbers';

// Include every tied result, ignoring missing counts while preserving real zeros.
export const tiedRankings = (rows = [], field, direction = 'max') => {
  const valid = rows.filter(row => toReportNumber(row?.[field]) != null);
  if (!valid.length) return [];
  const best = valid.reduce((value, row) => direction === 'min'
    ? Math.min(value, toReportNumber(row[field]))
    : Math.max(value, toReportNumber(row[field])), toReportNumber(valid[0][field]));
  return valid.filter(row => toReportNumber(row[field]) === best);
};
